import React, { Component, PropTypes } from "react";
import NavLink from "./NavLink.jsx";
import LogoutLink from "./LogoutLink.jsx";
import { Link } from "react-router";

class Navbar extends Component {
  state = {
    cookieClientAgreed: false
  };

  componentDidMount() {
    const cookieAgreement = !!localStorage.getItem("cookieAgreement");
    if (cookieAgreement) {
      this.setState({
        cookieClientAgreed: true
      });
    }
  }

  cookieAgree = e => {
    localStorage.setItem("cookieAgreement", "true");
    this.setState({
      cookieClientAgreed: true
    });
  };

  render() {
    const { cookieClientAgreed } = this.state;

    const {
      links,
      logoutAction,
      user,
      showMobileNav
    } = this.props;

    return (
      <header className="main_header">
        <div className="site--width">
          <div className="logo">
            <Link to="/">
              <img src="/assets/img/logo.png" alt="logo" />
            </Link>
          </div>
          <div className="header_nav">
            <ul>
              {links.map(e => (
                <NavLink link={e.link} text={e.text} />
              ))}
              {logoutAction && (
                <LogoutLink onClick={this.props.logoutAction} user={user} />
              )}
            </ul>
          </div>
        </div>

        <div className="navigation">
          <button
            id="sized"
            className="menu"
            onClick={showMobileNav}
          >
            <span />
          </button>
        </div>

        {!cookieClientAgreed && (
          <div className="cookies-popup">
            <div className="cookies-wrapper">
              <p>
                We use cookies to give you the best experience possible on our
                website, including analytics and content personalisation. By
                continuing to browse this website, you agree to the use of
                cookies.
                <Link to="/cookie_policy">Find out more</Link>
              </p>
              <button className="enter_med" onClick={this.cookieAgree}>
                Accept and close
              </button>
            </div>
          </div>
        )}
      </header>
    );
  }
}

Navbar.propTypes = {
  links: PropTypes.array,
  logoutAction: PropTypes.oneOfType([PropTypes.func, null])
};

export default Navbar;



/** WEBPACK FOOTER **
 ** ./src/components/Navbar/Navbar.jsx
 **/